import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { combineLatest, delay, filter, startWith } from 'rxjs';

import { PuSubscribable } from '@app/utils/pu-subscribe';
import {
  DownloadResult,
  InspectionsBulkDownloadService,
} from '@main-application/inspections/services/inspections-bulk-download.service';

@Component({
  selector: 'app-inspection-download-report',
  templateUrl: './inspection-download-report.component.html',
  styleUrls: ['./inspection-download-report.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InspectionDownloadReportComponent extends PuSubscribable implements OnInit {
  public dialogRef: MatDialogRef<InspectionDownloadReportComponent> = inject(MatDialogRef);
  public downloadService: InspectionsBulkDownloadService = inject(InspectionsBulkDownloadService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  progress$ = this.downloadService.progress$.pipe(startWith(0));
  isGenerating$ = this.downloadService.isGenerating$.pipe(startWith(true));
  failedDownloads: DownloadResult[] = [];
  isCompleted = false;

  constructor() {
    super();
  }

  ngOnInit(): void {
    combineLatest([this.progress$, this.isGenerating$])
      .pipe(
        delay(100),
        filter(([progress, isGenerating]) => progress === 1 && isGenerating === false)
      )
      .subscribe(() => {
        this.isCompleted = true;
        this.failedDownloads = this.downloadService.getFailedDownloads();
        this.cdr.detectChanges();
      })
      .untilDestroyed(this);
  }

  close() {
    this.dialogRef.close();
    this.downloadService.cleanAll();
  }
}
